// 智能文档管理页面
<template>
  <div class="flex" :style="isInDingTalk ? 'height:80vh' : ''">
    <!-- 路由导航 -->
    <div class="left-menu">
      <!-- :default-openeds="openGroup" -->
      <el-menu
        router
        :default-active="computedPath"
        active-text-color="#ec1c1c"
        @open="handleOpen"
      >
        <el-menu-item v-for="(meun, i) of docMenus" :key="i" :index="meun.url">
          <i
            :class="meun.icon"
            style="color:#a4bbe7;width:18px;height:18px"
          ></i>
          <span slot="title">{{ meun.name }}</span>
        </el-menu-item>
        <!-- 1225需求更改了路由导航 -->
        <!-- <el-submenu v-for="(meun, i) of docMenus" :key="i" :index="meun.url">
          <template slot="title">
            <i
              :class="meun.icon"
              style="color:#a4bbe7;width:18px;height:18px"
            ></i>
            <span>{{ meun.name }}</span>
          </template>
          <div v-if="meun.children && meun.children.length > 0">
            <el-menu-item
              v-for="(subMeun, k) of meun.children"
              :key="k"
              :index="subMeun.url"
            >
              <template slot="title">
                <img
                  :src="subMeun.icon"
                  width="18px"
                  height="18px"
                  style="margin-right:10px"
                  :alt="subMeun.name"
                />
                <span>{{ subMeun.name }}</span>
              </template>
            </el-menu-item>
          </div>
        </el-submenu> -->
      </el-menu>
    </div>
    <!-- 详情页面 -->
    <div class="view">
      <nuxt-child />
    </div>
  </div>
</template>

<script>
// 数据
import { docMenus } from "../assets/js/utils/docMenu";
import { isInDingTalk } from "../assets/js/utils/ding-env";

export default {
  data() {
    return {
      isInDingTalk,
      docMenus,
      openGroup: [this.$route.path]
    };
  },
  computed: {
    computedPath() {
      if (['/smartDoc/docDraft/draftList', '/smartDoc/docDraft/draft'].includes(this.$route.path)) {
        return '/smartDoc/docDraft/draftList'
      } else if (['/smartDoc/docExamine/examine', '/smartDoc/docExamine/examineList'].includes(this.$route.path)) {
        return '/smartDoc/docExamine/examineList'
      } else if (['/smartDoc/docExtract/extract', '/smartDoc/docExtract/extractList'].includes(this.$route.path)) {
        return '/smartDoc/docExtract/extractList'
      } else if (['/smartDoc/docContrast/contrastList', '/smartDoc/docContrast/contrast'].includes(this.$route.path)) {
        return '/smartDoc/docContrast/contrastList'
      } else {
        return this.$route.path
      }
    }
  },
  // data end
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
      this.openGroup = keyPath;
    }
  }
};
</script>

<style scoped lang="less">
  .el-menu-item.is-active {
    outline: 0;
    background-color: #ecf5ff;
  }
.left-menu {
  // width: 13vw;
  width: 230px;
  /*height: 85vh;*/
  /*margin-right: 10px;*/
  background: #fff;
  overflow: auto;
  color: #333;
  flex-shrink: 0;
}
.flex {
  display: flex;
  justify-content: space-between;
}
.view {
  /*width: calc(56vw - 30px);*/
  // width: calc(87vw - 30px);
  width: calc(1366px - 230px - 30px);
  /*height: 85vh;*/
  margin-left: 5px;
}
.dis-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// pages/smartDoc.vue